import { FontSize, fontSize } from "constants/fontSize";
import { NewColors, newColors } from "constants/newColors";
import React, { CSSProperties } from "react";
import styled, { css } from "styled-components";

export type PresenterProps = {
  text: string;
} & TypographyProps;

export type TypographyProps = {
  size?: FontSize;
  weight?: CSSProperties["fontWeight"];
  textAlign?: CSSProperties["textAlign"];
  color?: NewColors;
  backgroundColor?: CSSProperties["backgroundColor"];
  width?: CSSProperties["width"];
  required?: boolean;
};

const StyledTypography = styled.span<TypographyProps>`
  line-height: 1.1;
  word-break: break-all;
  overflow-wrap: break-word;
  word-wrap: break-word;

  font-size: ${({ size }) => {
    return size ? fontSize[size] : "inherit";
  }};
  font-weight: ${({ weight }) => weight || "inherit"};
  text-align: ${({ textAlign }) => textAlign || "left"};
  color: ${({ color }) => (color ? newColors[color] : "inherit")};
  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `};

  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `};

  ${({ required }) =>
    required &&
    css`
      ::after {
        content: "*";
        color: ${newColors.red};
      }
    `};
`;

export const TypographyPresenter: React.FC<PresenterProps> = ({
  text,
  ...props
}) => {
  return <StyledTypography {...props}>{text}</StyledTypography>;
};
